import React, { Component } from 'react';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import promiseMiddleware from 'redux-promise-middleware';

import './App.css';
import Router from './Router';
import reducers from './redux';
import { setErrorResponseHandler } from './utils/rest-service';
import { logout } from './redux/authentication/authentication_actions';

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = { isNetworkError: false };
    this.store = createStore(reducers, applyMiddleware(promiseMiddleware()));

    setErrorResponseHandler(error => {
      if (error.response) {
        if (error.response.status === 401) {
          this.store.dispatch(logout());
        }
        return Promise.reject(error);
      } else if (error.request) {
        return this.handleNetworkErrorRequest(error);
      } else {
        return Promise.reject(error);
      }
    });
  }

  handleNetworkErrorRequest(error) {
    this.setState({ isNetworkError: true });
    return Promise.reject({
      response: { data: { detail: error.message } },
    });
  }

  render() {
    const store = this.store;
    const { history } = this.props;
    const { isNetworkError } = this.state;
    return (
      <Provider store={store}>
        <Router
          history={history}
          isNetworkError={isNetworkError}
          onGlobalErrorHide={() => this.setState({ isNetworkError: false })}
        />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js